export default {
	SLIDE: 0,
	TEXT: 1,
}
